import { ApplicationConfig } from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { playMetaTagsProvider } from './play-meta-tags.provider'
import { gameSetupSiteBaseUrlProvider } from './game-setup-site-base-url.provider'
import { playIdentityConfigsProvider } from './play-identity-configs.provider'
import { StorageService, WindowService } from 'shared-services'
import {
  appNameProvider,
  closeLabelProvider,
  gamePlayPollingServiceProvider,
  gamePlayServiceProvider,
  inflightPromiseProvider,
  localeServiceProvider,
  logoAssetsProvider,
  userContextImplProvider,
  userContextNotifierProvider,
  userContextProvider,
  userGetterServiceProvider,
  userServiceProvider,
} from 'shared-components'
import { playGamePlayConfigProvider } from './play-game-play-config.provider'
import { biddingServiceProvider } from './bidding-service.provider'
import { dealingCardsPollTimeoutProvider } from './dealing-cards-poll-timeout.provider'
import { playEnvironmentNameProvider } from './play-environment-name.provider'
import { contractDeclarationServiceProvider } from './contract-declaration-service.provider'
import { defenderDeclarationServiceProvider } from './defender-declaration-service.provider'
import { settlingServiceProvider } from './settling-service.provider'
import { completedGamePollTimeoutProvider } from './completed-game-poll-timeout.provider'
import { playingGameServiceProvider } from './playing-game-service.provider'

export const playAppProviders: ApplicationConfig = {
  providers: [
    provideAnimations(),
    inflightPromiseProvider,
    playMetaTagsProvider,
    playIdentityConfigsProvider,
    gameSetupSiteBaseUrlProvider,
    WindowService,
    StorageService,
    localeServiceProvider,
    gamePlayPollingServiceProvider,
    gamePlayServiceProvider,
    playGamePlayConfigProvider,
    userContextImplProvider,
    userContextProvider,
    userContextNotifierProvider,
    userGetterServiceProvider,
    userServiceProvider,
    biddingServiceProvider,
    logoAssetsProvider,
    dealingCardsPollTimeoutProvider,
    playEnvironmentNameProvider,
    closeLabelProvider,
    contractDeclarationServiceProvider,
    defenderDeclarationServiceProvider,
    settlingServiceProvider,
    completedGamePollTimeoutProvider,
    playingGameServiceProvider,
    appNameProvider,
  ],
}
